exports.noScheduling = [
  "Product Support Referral",
  "Client Referral",
  "Office Referral",
  "Billing Referral",
  "Awaiting Parts",
  "Projects Referral",
  "Arrange Further Visit Attempt 1",
  "Arrange Further Visit Attempt 2",
];

exports.contactable = [
  "Arrange Further Visit Attempt 1",
  "Arrange Further Visit Attempt 2",
];

exports.showProgress = "Awaiting Parts";
